import { sendReports } from "./reportServices";
import { 
    initSendReports,
    sendReportsSuccess,
    sendReportsError,
    setSelectedReport,
    setEmails,
    setReportSucess
} from "./reportsSlice";

 export const sendReportsAction = (navigate, reportType, emails) => {
    return async dispatch => {
        const token = localStorage.getItem('token') || null;
        if (!token) {
            navigate('/login');
            return;
        }
        dispatch(initSendReports());
        try {
            const response = await sendReports(reportType, emails, token);
            if (response.status === 201) {
                dispatch(sendReportsSuccess());
            } else {
                dispatch(sendReportsError(response.data.message));
            }
        } catch (error) {
            dispatch(sendReportsError(error.message));
        }
    };
}

export const setSelectedReportAction = (reportType) => {
    return dispatch => {
        dispatch(setSelectedReport(reportType));
    };
}

export const setEmailsAction = (emails) => {
    return dispatch => {
        dispatch(setEmails(emails));
    };
}

export const clearReportsState = () => {
    return dispatch => {
        dispatch(setSelectedReport(null));
        dispatch(setEmails([]));
    };
}

export const clearErrorsAction = () => {
    return dispatch => {
        dispatch(sendReportsError(null));
    };
}

export const setReportSucessAction = (value) => {
    return dispatch => {
        dispatch(setReportSucess(value));
    };
}